<template>
  <div>
    <div class="code-box">
      滑动验证码完成验证
      <div id="duoge1" style="margin: 0.2rem 0">
        验证码没有加载出来哦，请点击
        <span @click="loadSelf">刷新</span>！
      </div>
    </div>
    <registeredTipsModal ref="tipsModal"/>
  </div>
</template>

<script>
import { sendCode, getMpSmsCaptcha, linkToProgram } from "@/api/land.js";
import { getLoginCode, checkoutCode, autocode } from "@/api/login";
import { sysWxActivityLogCode, scanVoucher } from "@/api/active";
import registeredTipsModal from '@/components/registeredTipsModal'
export default {
  name: "slider",
  data() {
    return {
      aliCode: {
        nc_token: "",
        csessionid: "",
        sig: "",
        scene: "register",
        phonenumber: "",
        channelCode: "",
        phoneInfo: ""
      }
    };
  },
  components: {registeredTipsModal},
  created() {
    let phone = navigator.userAgent; //设备机型的相关信息
    this.phoneInfo = phone.substring(
      phone.indexOf("(") + 1,
      phone.indexOf(";")
    ); //处理信息，输出phone
    var locationHref = window.location.href;
    if (locationHref.indexOf("?") > -1) {
      locationHref = decodeURI(locationHref);
      var param = "";
      if (locationHref.indexOf("&") > -1) {
        var params = locationHref.substring(
          locationHref.indexOf("?") + 1,
          locationHref.indexOf("&")
        );
        param = params.split("=")[1];
      } else {
        param = locationHref
          .substring(locationHref.indexOf("?") + 1)
          .split("=")[1];
      }
      this.aliCode.channelCode = param;
    }
  },
  mounted() {},
  props: ["phoneValue", "slider", "clickBtnNum", "types"],
  methods: {
    loadSelf() {
      window.location.reload();
      // this.$router.go(0);
    },
    getScroll(flag) {
      const that = this;
      this.aliCode.nc_token = [
        "CF_APP_1",
        new Date().getTime(),
        Math.random()
      ].join(":");
      var NC_Opt = {
        //声明滑动验证需要渲染的目标元素ID。
        renderTo: `#duoge1`,
        //应用类型标识。它和使用场景标识（scene字段）一起决定了滑动验证的业务场景与后端对应使用的策略模型。您可以在人机验证控制台的配置管理页签找到对应的appkey字段值，请务必正确填写。
        appkey: "FFFF0N00000000008984",
        //使用场景标识。它和应用类型标识（appkey字段）一起决定了滑动验证的业务场景与后端对应使用的策略模型。您可以在人机验证控制台的配置管理页签找到对应的scene值，请务必正确填写。
        scene: "register",
        //滑动验证码的主键，请勿将该字段定义为固定值。确保每个用户每次打开页面时，其token值都是不同的。系统默认的格式为：”您的appkey”+”时间戳”+”随机数”。
        token: this.aliCode.nc_token,
        //滑动条的宽度。
        customWidth: "5.6rem",
        //业务键字段，可为空。为便于线上问题的排查，建议您按照线上问题定位文档中推荐的方法配置该字段值。
        trans: { key1: "code0" },
        //语言。PC端Web页面场景默认支持18国语言，详细配置方法请参见自定义文案与多语言文档。
        language: "cn",
        //是否启用。一般情况，保持默认值（true）即可。
        isEnabled: true,
        //内部网络请求的超时时间。一般情况建议保持默认值（3000ms）。
        timeout: 3000,
        //允许服务器超时重复次数，默认5次。超过重复次数后将触发报错。
        times: 1,
        //前端滑动验证通过时会触发该回调参数。您可以在该回调参数中将请求标识（token）、会话ID（sessionid）、签名串（sig）字段记录下来，随业务请求一同发送至您的服务端调用验签。
        callback: function(data) {
          if (data.csessionid && data.sig) {
            that.aliCode.csessionid = data.csessionid;
            that.aliCode.sig = data.sig;
            that.aliCode.phonenumber = that.phoneValue;
            //  let formData = new FormData();
            // formData.append('aliCode', that.aliCode)
            // console.log(formData.get('aliCode'))
            let headers = {
              processData: "false",
              contentType: "false"
            };
            let api = null;
            if (flag == "0") {
              that.aliCode.mobile = that.phoneValue;
              api = getMpSmsCaptcha;
            } else if (flag == "1") {
              that.aliCode.mobile = that.phoneValue;
              api = getLoginCode;
            } else if (flag == "2") {
              that.aliCode.phonenumber = that.phoneValue;
              api = checkoutCode;
            } else if (flag == "3") {
              that.aliCode.phonenumber = that.phoneValue;
              api = sysWxActivityLogCode;
              that.aliCode.activityId = 1;
            } else if (flag == "4") {
              that.aliCode.phoneNumber = that.phoneValue;
              api = scanVoucher;
            } else if (flag == "5") {
              that.aliCode.mobile = that.phoneValue;
              // api = autocode
              api = getLoginCode;
            } else {
              api = sendCode;
            }
            api(that.aliCode)
              .then(res => {
                if (flag == "11" && res.data == '{"result":"fail"}') {
                  that.$emit("sliderSuccess", "fail");
                } else {
                  if (res.code == 0) {
                    if (flag == "2") {
                      that.$toast({ message: res.msg });
                    } else {
                      that.$toast({
                        message: "验证码发送成功，请留意您的手机信息"
                      });
                    }
                    that.$emit("sliderSuccess", that.aliCode);
                  } else {
                    if(res.msg == '账号已存在') {
                      that.$refs.tipsModal.show('账号已存在')
                      that.$emit("sliderSuccess", "error")
                    } else {
                      let msg = "系统错误请稍后重试";
                      if (res.msg) {
                        msg = res.msg;
                      }
                      that.$toast({ message: msg });
                      that.$emit("sliderSuccess", "error")
                    }
                  }
                }
                nc.reset();
              })
              .catch(error => {
                that.$emit("sliderSuccess", "error");
                nc.reset();
              });
          } else {
            that.$toast({ message: "验证失败！" });
            that.$emit("sliderSuccess", "error");
            nc.reset();
          }
        }
      };
      var nc = new noCaptcha(NC_Opt);
      //用于自定义文案。详细配置方法请参见自定义文案与多语言文档。
      nc.upLang("cn", {
        _startTEXT: "请按住滑块，拖动到最右边",
        _yesTEXT: "验证通过",
        _error300:
          '哎呀，出错了，点击<a href="javascript:__nc.reset()">刷新</a>再来一次',
        _errorNetwork:
          '网络不给力，请<a href="javascript:__nc.reset()">点击刷新</a>'
      });
    }
  }
};
</script>

<style scoped>
.code-box {
  background: white;
  padding: 0.2rem;
  border-radius: 0.2rem;
  text-align: left;
  position: absolute;
  width: 6rem;
  top: 50%;
  margin-top: -50px;
  left: 50%;
  margin-left: -3.1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/slider.vue